const gnxOrders_en = () => ({
  'orders.title': 'orders',
  'orders.subtitle': 'this is a web component with orders',
  'orders.order.description': 'Description',
  'orders.order.deliveryGlobalId': 'Order',
  'orders.order.address': 'Adress',
  'orders.order.courier': 'Courier',
  'orders.order.state': 'State',
  'orders.order.points': 'Total Amount',
  'orders.order.button.detail': 'Detail',
  'orders.order.button.confirmation': 'To confirm order',
  'orders.order.button.download': 'Download voucher',
  'orders.order.state.processing': 'Processing',
  'orders.order.state.confirm_received': 'Confirm Received',
  'orders.order.state.acepted': 'Acepted',
  'orders.order.state.pending': 'Pending',
  'orders.order.state.canceled': 'Canceled',
  'orders.order.state.delivered': 'Delivered',
  'orders.order.state.delivered_fail': 'Delivered Fail',
  'orders.order.state.departed': 'Departed',
  'orders.order.contact.name': 'Contact',
  'orders.order.contact.document': 'Document',
  'orders.order.trackingId': 'Tracking number',
  'orders.order.phone.operator': 'Operator',
  'orders.order.detail.globalId': 'Order',
  'orders.order.detail.trackingNumber': 'Tracking number',
  'orders.order.detail.items': 'items',
  'orders.order.detail.pointz': 'points',
  'orders.order.detail.orderInformation': 'Order information',
  'orders.order.detail.shippingAddress': 'Shipping address',
  'orders.order.detail.paymentMethod': 'Payment Method',
  'orders.order.detail.deliveredMethod': 'Delivered Method',
  'orders.order.detail.courier': 'Courier',
  'orders.order.detail.totalMount': 'Total mount',
  'orders.preorder.adressText': 'Delivery address',
  'orders.preorder.adressButton': 'Change',
  'orders.preorder.quantity': 'Quantity',
  'orders.preorder.shippingContact': 'Shipping contact',
  'orders.preorder.confirmYourOrder': 'Confirm your order',
  'orders.preorder.contactInfo.name': 'Name',
  'orders.preorder.contactInfo.lastName': 'LastName',
  'orders.preorder.contactInfo.phone': 'Phone',
  'orders.preorder.contactInfo.phone2': 'Other Phone (optional)',
  'orders.preorder.contactInfo.email': 'Email',
});

const en = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': gnxOrders_en
});

const gnxOrders_es = () => ({
  'orders.title': 'Ordenees',
  'orders.subtitle': 'Este es el web component de ordenes',
  'orders.order.description': 'Descripción',
  'orders.order.deliveryGlobalId': 'Orden',
  'orders.order.address': 'Direccion',
  'orders.order.courier': 'Transportadora',
  'orders.order.state': 'Estado',
  'orders.order.quantity': 'Cantidad',
  'orders.order.points': 'Total',
  'orders.order.button.detail': 'Detalle',
  'orders.order.button.confirmation': 'Confirmar',
  'orders.order.button.download': 'Descargar',
  'orders.order.state.processing': 'Procesando',
  'orders.order.state.confirm_received': 'Entrega Confirmada',
  'orders.order.state.acepted': 'Aceptado',
  'orders.order.state.pending': 'Pendiente',
  'orders.order.state.canceled': 'Cancelado',
  'orders.order.state.delivered': 'Entregado',
  'orders.order.state.delivered_fail': 'Entrega fallida',
  'orders.order.state.departed': 'En reparto',
  'orders.order.contact.name': 'Contacto',
  'orders.order.contact.document': 'Documento',
  'orders.order.trackingId': 'Numero de guia',
  'orders.order.phone.operator': 'Operador',
  'orders.order.detail.globalId': 'Orden',
  'orders.order.detail.trackingNumber': 'Numero de guia',
  'orders.order.detail.items': 'items',
  'orders.order.detail.pointz': 'points',
  'orders.order.detail.orderInformation': 'Informacion de la orden',
  'orders.order.detail.shippingAddress': 'Dirección de entrega',
  'orders.order.detail.paymentMethod': 'Metodo de pago',
  'orders.order.detail.deliveredMethod': 'Metodo de entrega',
  'orders.order.detail.courier': 'Transportadora',
  'orders.order.detail.totalMount': 'Cantidad total',
  'orders.order.detail.titleCourier': 'Estado de envio para los productos redimidos:',
  'orders.order.detail.numberGuide': 'Número de guia:',
  'orders.order.detail.courier': 'Transportadora:',
  'orders.preorder.adressText': 'Dirección de entrega',
  'orders.preorder.adressButton': 'Cambiar',
  'orders.preorder.quantity': 'Cantidad',
  'orders.preorder.shippingContact': 'Información de contacto',
  'orders.preorder.confirmYourOrder': 'Confirma tu orden',
  'orders.preorder.contactInfo.name': 'Nombre',
  'orders.preorder.contactInfo.lastName': 'Apellido',
  'orders.preorder.contactInfo.phone': 'Teléfono',
  'orders.preorder.contactInfo.phone2': 'Teléfono adicional',
  'orders.preorder.contactInfo.email': 'Email',
  'orders.preorder.contactInfo.birthday': 'Fecha de nacimiento',
  'orders.preorder.contactInfo.select': 'Selecciona un valor',
  'orders.address.addressForm.nameDir':'Nombre personalizado',
  'orders.address.addressForm.dpto': 'Departamento',
  'orders.address.addressForm.city':'Ciudad',
  'orders.address.addressForm.locality':'Localidad',
  'orders.address.addressForm.address':'Dirección',
  'orders.address.addressForm.postalCode':'Código postal',
  'orders.address.addressForm.reference':'Punto de referencia',
  'orders.address.addressForm.dptoEC': 'Provincia',
  'orders.address.addressForm.cityEC':'Cantón',
  'orders.address.addressForm.localityEC':'Parroquía',
  'orders.address.addressForm.cityCAM':'Municipio',
  'orders.address.addressForm.localityCAM':'Barrio',
});

const es = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': gnxOrders_es
});

const gnxOrders_fr = () => ({
  'orders.title': 'orders',
  'orders.subtitle': 'this is a web component with orders',
  'orders.order.description': 'Description',
  'orders.order.deliveryGlobalId': 'Delivery ID',
  'orders.order.address': 'Adress',
  'orders.order.courier': 'Courier',
  'orders.order.state': 'State',
  'orders.order.points': 'Total Amount',
  'orders.order.button.detail': 'Detail',
  'orders.order.button.confirmation': 'To confirm order',
  'orders.order.state.processing': 'Processing',
  'orders.order.state.acepted': 'Acepted',
  'orders.order.state.pending': 'Pending',
  'orders.order.state.canceled': 'Canceled',
  'orders.order.state.delivered': 'Delivered',
  'orders.order.state.delivered_fail': 'Delivered Fail',
  'orders.order.state.departed': 'Departed',
  'orders.order.contact.name': 'Contact',
  'orders.order.contact.document': 'Document',
  'orders.order.trackingId': 'Tracking ID',
  'orders.order.phone.operator': 'Operator',
});

const fr = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': gnxOrders_fr
});

function getComponentClosestLanguage(element) {
  let closestElement = element.closest('[lang]');
  return closestElement ? closestElement.lang : 'en';
}
function fetchLocaleStringsForComponent(componentName, locale) {
  return new Promise((resolve, reject) => {
    resolve(selectLanguaje(locale).default());
  });
}

async function getLocaleComponentStrings(element) {
  let componentName = element.tagName.toLowerCase();
  let componentLanguage = getComponentClosestLanguage(element);
  let strings;
  try {
    strings = await fetchLocaleStringsForComponent(componentName, componentLanguage);
  } catch (e) {
    strings = await fetchLocaleStringsForComponent(componentName, 'en');
  }
  return strings;
}

function selectLanguaje(locale) {
  switch (locale) {
    case 'es':
      return es;
    case 'fr':
      return fr;
    case 'en':
      return en;
  }
}

export { getLocaleComponentStrings as g };
